<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="displays">
<h1>Displays</h1>
<p>You may well inherit a classroom where the walls are covered in tat. You know the sort of thing I mean, ripped, torn or graffiti-daubed backing paper, ageing examples of pupils’ work dating back years, sometimes decades, fading posters, the previous teacher’s collection of dog photographs, prehistoric notices written by long-since-retired senior staff. If you have time, try to smarten things up. A few well-chosen posters and fairly bare walls will create a better impression. Of course, you might ‘redecorate’ completely but it will take a lot longer than you think. Simply removing staples from display boards is tedious, nail-breaking and hugely time-consuming. Ultimately, though, the quality of your displays articulates a great deal about you and sets a non-verbal tone for your room.</p>
<p>I spend quite a bit of my time interviewing pupils for Sixth Form places. It is always interesting to ask pupils why they picked their chosen 16+ courses. Recently, one pupil explained to me that she had decided to study politics because she had had a room change and had spent one lesson in a room where the member of staff taught politics. She had been so impressed and fascinated by the displays that she had been convinced that politics was the subject for her.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch011.vue?16f0797c